webpackJsonp([281442474239850],{

/***/ 919:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"title":"The dangers of AVX-512 throttling: a 3% impact","createdAt":"11 hours ago","by":"zdw","comments":[{"text":"This might be a bit...too far out there, but could there be side channel attacks via cpu heating? Like heating the cpu to near borderline with AVX512 and seeing if a hyperthread causes throttling due to some “heavy” aes instruction. Sounds unlikely to be exploitable though.<p>Ever since specter I’m thinking of any performance changes by previous instructions might be exploitable. Again thermal throttling might be a bit too far out there since it’s not _that_ deterministic. Fun thought though!","by":"NightMKoder","timeISO":"7 hours ago"},{"text":"From my (admittedly little) understanding, part of the concern was that a user on part of the CPU could degrade performance for other users by sucking up proportionally more of the heat budget of the entire CPU, triggering throttling. Is this what was tested here?","by":"JimmyAustin","timeISO":"8 hours ago"}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---comment-17771232-7817dd6412bb99bb82fb.js